<template>
  <w-sliding-popup ref="slidingPopup" :title="eventDataSize === 1 ? '이벤트 수동 해제' : '이벤트 일괄 수동 해제'" width="950px">
    <div slot="content">
      <div v-if="eventDataSize === 1">
        <div class="title-h4 title-bar">이벤트 정보</div>
        <el-input style="margin-bottom:15px;" readonly resize="none" type="textarea" v-model="formData.eventMessage" :rows="2"></el-input>
        <el-row class="form-list mr-b25" :gutter="15">
          <el-col :span="12">
            <el-form ref="form" label-position="left">
              <el-form-item label="대상" label-width="120px">{{formData.objName}}</el-form-item>
              <el-form-item label="관리구분" label-width="120px">{{formData.managetypeName}}</el-form-item>
              <el-form-item label="장애티켓 발생여부" label-width="120px">{{formData.troubleStatus}}</el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form ref="form" size="mini" label-position="left">
              <el-form-item label="등급" label-width="120px">{{formData.eventlevelName}}</el-form-item>
              <el-form-item label="자원구분" label-width="120px">{{formData.rsctypeName}}</el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="title-h4 title-bar">수동 해제 사유</div>
      <el-input resize="none" type="textarea" v-model="formData.releaseMessage" :rows="5" class="ticket-input-class"></el-input>
      <div style="font-size:13px; margin-top:4px;">경고 ) 수동 해제 시 해당 이벤트는 이벤트 현황에서 제외되며, 해제를 실행한 계정과 시각이 이력으로 기록됩니다.</div>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" @click="releaseEvent">수동해제</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import EventStatusAPI from '@/api/event/event-status';

export default {
  name: 'WEventReleasePopup',
  props: {
    eventData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        eventMessage: null,
        objName: null,
        eventlevelName: null,
        managetypeName: null,
        rsctypeName: null,
        troubleStatus: null,
        releaseMessage: null,
      },
    };
  },
  computed: {
    eventDataSize() {
      if (isEmpty(this.eventData)) {
        return 1;
      }
      return this.eventData.length;
    },
  },
  watch: {
    eventData: {
      handler(to) {
        if (!isEmpty(to) || to.length === 1) {
          this.formData = {
            eventMessage: to[0].eventMessage,
            objName: to[0].targetInfo,
            eventlevelName: to[0].eventlevelName,
            managetypeName: to[0].managetypeName,
            rsctypeName: to[0].rsctypeName,
            troubleStatus: to[0].troubleStatusName,
            releaseMessage: null,
          };
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.$refs.slidingPopup.close();
    },
    releaseEvent() {
      const params = [];
      this.eventData.forEach((item) => {
        if (item.managetypeId !== 'SVC') {
          params.push({
            objId: item.objId,
            hashkeyIdString: item.hashkeyIdString,
            managetypeId: item.managetypeId,
            rsctypeId: item.rsctypeId,
            rscId: item.rscId,
            rscKey: item.rscKey,
            eventMessage: item.eventMessage,
            releaseMessage: this.formData.releaseMessage,
            firstSeqNumber: item.firstSeqNumber,
          });
        }
      });
      const target = '이벤트';
      const action = '수동으로 해제';
      EventStatusAPI.releaseEvent(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.close();
          this.$emit('reload');
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-status/popup/EventReleasePopup.vue